import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { HomeEnComponent } from './home-en/home-en.component';
import { HomeArComponent } from './home-ar/home-ar.component';
import { ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FieldErrorModule } from './field-error/field-error.module';
import { RouterModule } from '@angular/router';
import { EstateEnComponent } from './estate-en/estate-en.component';
import { EstateArComponent } from './estate-ar/estate-ar.component';
import { ProjectModule } from './projects/project.module';
import { AllegriaComponent } from './allegria/allegria.component';
import { AllegriaArComponent } from './allegria-ar/allegria-ar.component';
import { VyeEnComponent } from './vye-en/vye-en.component';
import { VyeArComponent } from './vye-ar/vye-ar.component';
import { EastvaleEnComponent } from './eastvale-en/eastvale-en.component';
import { EastvaleArComponent } from './eastvale-ar/eastvale-ar.component';

@NgModule ({ declarations: [
        AppComponent,
        HomeEnComponent,
        HomeArComponent,
        EstateEnComponent,
        EstateArComponent,
        AllegriaComponent,
        AllegriaArComponent,
        VyeEnComponent,
        VyeArComponent,
        EastvaleEnComponent,
        EastvaleArComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        CarouselModule,
        RouterModule,
        ReactiveFormsModule,
        FieldErrorModule,
        ProjectModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {
}
